import cn from 'classnames';
import { useRootSelector } from '../../../../../../store/hooks';
import { selectLeadGenForm } from '../../../../../../store/features/leadGen';
import { selectSiteHeaderData } from '../../../../../../store/features/siteHeader';
import ImageTag from '../../../../../shared/ImageTag/ImageTag';
import s from './Layout.module.scss';

export default function Layout({ children }) {
  const { title: eventTitle } = useRootSelector(selectSiteHeaderData);
  const {
    teaser: {
      teaserHeading: title = `${eventTitle} Agenda`,
      teaserBody: text,
      thumbnail,
      thumbStyle,
    } = {},
  } = useRootSelector(selectLeadGenForm);

  const leftColumnClassName = cn('col-xs-12', {
    'col-md-4': thumbStyle === 'PORTRAIT',
    'col-md-6': thumbStyle === 'LANDSCAPE',
  });

  const rightColumnClassName = cn('col-xs-12', {
    'col-md-8': thumbStyle === 'PORTRAIT',
    'col-md-6': thumbStyle === 'LANDSCAPE',
  });

  return (
    <div className={s.wrapper}>
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            {title && <h1 className={s.title}>{title}</h1>}
          </div>
        </div>
        <div className="row">
          <div className={leftColumnClassName}>
            {thumbStyle !== 'NONE' && thumbnail?.path && (
              <ImageTag lazy={false} src={thumbnail.path} className={s.image} />
            )}
            {text && (
              <div
                dangerouslySetInnerHTML={{
                  __html: text,
                }}
                className={cn(s.text, 'formatted-text')}
              />
            )}
          </div>
          <div className={rightColumnClassName}>
            <div className={s.form}>{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
